// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__4je4J","header":"ReportDetails_header__YJKhx","title":"ReportDetails_title__3FxN1","left":"ReportDetails_left__Au-5q"};